export class Provincia {
    codProvincia: number;
    codPais: number;
    nomProvincia: string;
}
